<script lang="ts">
  import {
    statusFilterOptions,
    createDepartmentOptions,
    createUserOptions
  } from "./data"
  import { appStore } from "$app/store.svelte"
  import { Building, User } from "lucide-svelte"
  import {
    present_user,
    present_department,
    present_status
  } from "./Snippets.svelte"

  interface Props {
    filter?: string
    page: string
    filters: FilterType[]
    onaddfilter: (filter: FilterType) => void
    ontab: (tab: string) => void
  }

  let { filter = "", page, filters, onaddfilter, ontab }: Props = $props()
  let index: number = $state(null)
  let reg: RegExp = $state()

  const userRoles: RoleType[] = ["admin", "leader", "manager", "member"]

  const usersList: UserType[] = appStore.users.filter((u) =>
    userRoles.includes(u.role)
  )
  let users = [...usersList]
  export function resetIndex() {
    index = null
  }

  export function moveDown(): void {
    if (index === null) {
      index = 0
      return
    }
    if (index + 1 === filterOptions.length) {
      index = 0
    } else {
      index++
    }
  }

  export function moveUp() {
    if (index === null) {
      index = filterOptions.length - 1
      return
    }
    if (index === 0) {
      index = filterOptions.length - 1
    } else {
      index--
    }
  }

  export function selectIndex() {
    if (index !== null) {
      const filter = filterOptions[index]
      onaddfilter(filter)
      index = null
    }
  }

  let filterOptions: FilterType[] = $state([])

  let tab = $state("status")

  function setTab(txt): void {
    tab = txt
    index = 0
    ontab(tab)
  }

  if (page === "my_progress") {
    tab = ""
  } else {
    tab = "status"
  }

  const currentFilters = filters
    .filter((el) => el.type === tab)
    .map((v) => v.value)

  let opts: FilterType[] = []

  $effect(() => {
    switch (tab) {
      case "department":
        opts = createDepartmentOptions(appStore.departments).filter(
          (v) => !currentFilters.includes(v.value)
        )
        break
      case "user":
        opts = createUserOptions(users).filter(
          (v) => !currentFilters.includes(v.value)
        )
        break
      case "status":
        opts = statusFilterOptions.filter(
          (v) => !currentFilters.includes(v.value)
        )
        break
      default:
        opts = []
    }
    if (filter !== undefined && filter !== "") {
      filterOptions = opts.filter((st) => {
        reg = new RegExp(filter, "ig")
        return reg.test(st.label)
      })
    } else {
      filterOptions = opts
    }
  })
</script>

<div class="autocomplete-container">
  {#if page !== "my_progress"}
    <div class="px-4 py-1 tabs flex items-center gap-2">
      <button
        class="rounded button-tab flex items-center px-3 py-4 h-24"
        class:active={tab === "status"}
        onclick={() => setTab("status")}
      >
        <span
          class="flex-none h-4 w-4 rounded-full mr-1 inline-block {tab ===
          'status'
            ? 'bg-white'
            : 'bg-gray-500'}"
        ></span>
        Status
      </button>
      <button
        class="rounded button-tab px-3 py-4 h-24 inline-flex items-center"
        class:active={tab === "department"}
        onclick={() => setTab("department")}
      >
        <Building class="size-4" />
        Department
      </button>
      <button
        class="rounded button-tab inline-flex items-center px-3 py-4 h-24"
        class:active={tab === "user"}
        onclick={() => setTab("user")}
        class:hidden={page !== "assignee"}
      >
        <User class="size-4" />
        User
      </button>
    </div>
  {/if}

  {#if tab === "status"}
    <div class="" data-name="statuses">
      {#each filterOptions as status, idx (status.value)}
        <button
          class="px-4 py-2 cursor-pointer item w-full text-left"
          class:bg-blue-100={idx === index}
          onmouseenter={() => {
            index = idx
          }}
          onclick={() => {
            onaddfilter(status)
            index = null
          }}
        >
          {@render present_status(status)}
        </button>
      {/each}
    </div>
  {/if}

  {#if tab === "department"}
    <div class="" data-name="departments">
      {#each filterOptions as dept, idx (dept.value)}
        <button
          class="px-4 py-2 cursor-pointer item w-full text-left"
          class:bg-blue-100={idx === index}
          onmouseenter={() => {
            index = idx
          }}
          onclick={() => {
            onaddfilter(dept)
            index = null
          }}
        >
          {@render present_department(dept)}
        </button>
      {/each}
    </div>
  {/if}

  {#if page === "assignee" || tab === "user"}
    <div>
      {#each filterOptions as user, idx (user.value)}
        <button
          class="px-4 py-2 cursor-pointer item w-full text-left"
          class:bg-blue-100={idx === index}
          onmouseenter={() => {
            index = idx
          }}
          onclick={() => {
            onaddfilter(user)
            index = null
          }}
        >
          {@render present_user(user)}
        </button>
      {/each}
    </div>
  {/if}
</div>

<style lang="css">
  .autocomplete-container {
    max-height: 50vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .tabs button {
    height: 2rem;
    background-color: #dbe9fe;
    font-weight: 600;
    color: #6b7280;
  }
  .tabs button img {
    filter: invert(50%);
  }
  .tabs button.active {
    background-color: #075985;
    color: white;
  }
  .tabs button.active img {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(292deg)
      brightness(103%) contrast(103%);
  }
</style>
